(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebook-product-sales-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-ebook-carousel-prev], [data-ebook-carousel-next]');
    if (!control) return;

    const preview = control.closest('.ebook-sales__preview')?.querySelector('[data-ebook-carousel]');
    const slide = preview?.querySelector('[data-ebook-slide]');
    if (!preview || !slide) return;

    const gap = Number.parseFloat(getComputedStyle(preview).gap) || 0;
    const direction = control.hasAttribute('data-ebook-carousel-prev') ? -1 : 1;
    preview.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior: 'smooth' });
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ebook-scroll-buy]');
    if (!trigger) return;

    const purchaseArea = document.getElementById('EbookProductBuy');
    if (!purchaseArea) return;

    event.preventDefault();
    purchaseArea.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
